import React, { Component } from 'react';
import Button from 'app/common/react/components/growth/unauth/Button/Button';
import changeWindowLocation from 'app/common/lib/util/changeWindowLocation';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import templateConst from 'app/common/lib/templateConst';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import { BoldFontFamily } from 'app/common/react/components/common/FontFamily';

const styles = {
  privacyLink: {
    backgroundColor: '#fff',
    borderRadius: '4px',
    boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.1), 0 0 0 0.5px rgba(0, 0, 0, 0.04)',
    color: '#333',
    fontFamily: BoldFontFamily,
    fontSize: '12px',
    fontWeight: 'normal',
    padding: '2px 5px 3px',
    position: 'fixed',
    right: '10px',
  },
};

export class OpenPrivacyLink extends Component {
  handlePrivacyButtonClick = () => {
    trackRegisterAction('unauth.privacyButtonClicked.' + this.context.pageType);
    changeWindowLocation(templateConst.settings.ABOUT_PRIVACY_URL, true);
  };

  render() {
    return (
      <Button className="noButtonStyles" onClick={this.handlePrivacyButtonClick}>
        <div style={{ ...styles.privacyLink, bottom: this.props.hasBanner ? '80px' : '10px' }}>
          {i18n._('Privacy')}
        </div>
      </Button>
    );
  }
}

OpenPrivacyLink.propTypes = {
  hasBanner: PropTypes.bool,
  bannerHeight: PropTypes.number,
};

OpenPrivacyLink.contextTypes = {
  pageType: PropTypes.string.isRequired,
};

export default OpenPrivacyLink;
